// Tunable gameplay + presentation settings. Pure data (no DOM), so the sim can
// read it directly. `settings.ts` loads/saves the mutable `config` to
// localStorage and the settings menu edits it live.

export interface GameConfig {
  /** Damage a zombie deals to the player per hit. */
  zombieAttackDamage: number;
  /** Seconds between a zombie's melee swings. */
  zombieAttackInterval: number;
  /** Damage the player deals to a mob per hit (hand). */
  playerAttackDamage: number;
  /** Radians of yaw/pitch per pixel of mouse movement. */
  mouseSensitivity: number;
  /** Camera field of view in degrees. */
  fov: number;
  /** Chunk render distance. */
  viewDistanceChunks: number;
  /** Master audio volume 0..1. */
  masterVolume: number;
}

export const DEFAULT_CONFIG: GameConfig = {
  zombieAttackDamage: 3,
  zombieAttackInterval: 1.0,
  playerAttackDamage: 4,
  mouseSensitivity: 0.0022,
  fov: 75,
  viewDistanceChunks: 8,
  masterVolume: 0.6,
};

/** The live config, mutated by the settings menu. */
export const config: GameConfig = { ...DEFAULT_CONFIG };
